import React, {ComponentType} from "react";
import styles from "./centered-page-container.module.css";


const CenteredPageContainer: React.FC<{ component: ComponentType<any> }> = (props) => {




    return (
        <div className={styles.page_container}>
            <div className={styles.centered_content}>
                <props.component/>
            </div>

        </div>
    );

}


export default CenteredPageContainer;

